import SelectorComponents from './Selector.vue';

const selector = {
    install:function(Vue) {
        Vue.component('selector', SelectorComponents)
    }
}

export default selector;